import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
//import reportWebVitals from './reportWebVitals';
import {GoogleRecaptchaWrapper} from './GoogleRecaptchWraper';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <HelmetProvider>
    <GoogleRecaptchaWrapper
    reCaptchaKey="6LcF7NoZAAAAALGM1XQnKFyMq19MB6-RPxLFA8XU"
    scriptProps={{
      async: true, // optional, default to false,
      defer: true, // optional, default to false
      appendTo: 'body', // optional, default to "head", can be "head" or "body",
      
    }}
    >
    <App />
    </GoogleRecaptchaWrapper>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log)